import { PaginationBody } from '@Entities/pagination'
import { AxiosResponse } from 'axios'
import { axiosClient } from '@App/api/api-client'
import Pathes from '@App/dicts/pathes'
import { CowriterSearch } from '@App/stores/search/models/cowriter-search'
import { ResultPage } from '@Entities/result-page'

import { WriterModel } from '@Entities/work/writer-model'

export const searchCowriters = (
    songwriterId: string,
    pagination: PaginationBody,
    search: CowriterSearch
): Promise<AxiosResponse<ResultPage<WriterModel>>> =>
    axiosClient.post<ResultPage<WriterModel>>(Pathes.Songwriter.searchCowriters(songwriterId, pagination), search)
